import { render } from "./TrainingRoleDashboard.vue?vue&type=template&id=39779612&scoped=true"
import script from "./TrainingRoleDashboard.vue?vue&type=script&lang=js"
export * from "./TrainingRoleDashboard.vue?vue&type=script&lang=js"

import "./TrainingRoleDashboard.vue?vue&type=style&index=0&id=39779612&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39779612"]])

export default __exports__